export default "__VITE_ASSET__ClsI3J8Y__"